// extracted by mini-css-extract-plugin
export default {"spacer":"MenuList_spacer__7SGq0"};